import createUrlBuilder from 'utilities/url.builder.utils';
import {
  getRequest,
  postRequest,
  deleteRequest
} from 'utilities/service.utils';
import AppService from './app.service.context';
import { AddUserRequest, DeleteUserRequest } from 'redux/organisation/types';

export const fetchUsersByOrganisationId = async (organisationId: string) => {
  const urlBuilder = createUrlBuilder(
    `/community/organisations/${organisationId}/users`
  );
  return await getRequest(AppService, urlBuilder.toString());
};

export const deleteUser = async (deleteUserRequest: DeleteUserRequest) => {
  const { orgId, id } = deleteUserRequest;
  const urlBuilder = createUrlBuilder(
    `/community/organisations/${orgId}/users/${id}`
  );
  return await deleteRequest(AppService, urlBuilder.toString());
};

export const addOrganisationUser = async (addUserRequest: AddUserRequest) => {
  const { orgId, ...payload } = addUserRequest;
  const urlBuilder = await createUrlBuilder(
    `/community/organisations/${orgId}/users`
  );
  return await postRequest(AppService, urlBuilder.toString(), payload);
};
